import CustomButton from "src/components/common/CustomButton";
import { GoogleOutlined } from "@ant-design/icons";

const GoogleLoginButton = () => {
  const login = () => {
    window.location.href = `${process.env.REACT_APP_OMS_SERVER_API}/admin/oauth2/authorization/google-admin`;
  };

  return (
    <CustomButton
      variant="contained"
      onClick={() => login()}
      style={{
        width: 110,
        height: 110,
        borderRadius: "50%",
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
      }}
    >
      <GoogleOutlined style={{ fontSize: 60 }} />
    </CustomButton>
  );
};

export default GoogleLoginButton;
